import { createFileRoute } from '@tanstack/react-router';
import Installation from '../../../administration/src/components/Apps/AppDetails/Installation';

export const Route = createFileRoute('/_secured/administration/apps/$appId/installation')({
  component: Installation,
});
